import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../Button';
import { useAuth } from '../../../lib/auth';

export const IdentityProcessingPopup = () => {
  const { t } = useTranslation();
  const { getCurrentUser } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleRefresh = async () => {
    setLoading(true);
    try {
      await getCurrentUser();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="absolute bg-white z-status-popup left-[36px] right-[36px] top-[32px] shadow-lg flex flex-col p-6">
      <div className="text-lg text-center text-primary font-bold">
        {t('identityProcessingPopup.title')}
      </div>
      <div className="my-4 text-sm text-center text-gray-600">
        {t('identityProcessingPopup.body')}
      </div>
      {/* <div className="mb-4 text-xs text-center text-gray-400">
        {t('identityProcessingPopup.hint')}
      </div> */}
      <div className="mb-2 text-xs text-center text-gray-400">
        {t('identityProcessingPopup.refreshHint')}
      </div>
      <Button
        className="text-sm"
        type="outline"
        onClick={handleRefresh}
        disabled={loading}
      >
        {t('identityProcessingPopup.refresh')}
      </Button>
    </div>
  );
};
